module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-BLOG-PLOT-5-5-small-7967b1c762e00e7aaeccd2b37e54c96f.png";